import HttpRequest from './httpRequest'

export default class OrderProvider extends HttpRequest {
  createOrder(params) {
    return this.create('/orders', params)
  }

  fetchOrderById(id) {
    return this.fetch(`/orders/${id}`)
  }

  fetchOrders(params) {
    return this.fetch('/orders', params)
  }

  fetchOrdersByUserId(params) {
    return this.fetch('/orders/users', params)
  }

  updateOrderById(id, params) {
    return this.update(`/orders/${id}`, params)
  }

  updateOrderPayments(id, params) {
    return this.update(`/orders/payments/${id}`, params)
  }

  deleteOrderById(id) {
    return this.update(`/orders/delete/${id}`)
  }

  fetchRevenue (id) {
    return this.fetch(`/orders/revenue/${id}`)
  }
}
